import React, { useEffect, useState } from "react";
import "./TokenPreviewPanel.css";

// Helper to get all custom properties defined on :root
const getTokenNames = () => {
  const root = document.documentElement;
  const all = getComputedStyle(root);
  const names = [];
  for (let i = 0; i < all.length; i++) {
    const name = all[i];
    if (name.startsWith("--")) names.push(name);
  }
  return names;
};

const Section = ({ title, tokens }) => (
  <section>
    <h3>{title}</h3>
    <div className="grid-rows">
      {tokens.map((name) => {
        const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
        // Render swatch for colors, display for text, etc
        const isColor = name.includes("color") && value;
        const style = { width: "150px", height: "40px", backgroundColor: isColor ? value : undefined };
        return (
          <div key={name} className="token-row" style={style}>
            <span>{name}</span>
            <span>{value}</span>
          </div>
        );
      })}
    </div>
  </section>
);

const TokenPreviewPanel = () => {
  const [tokens, setTokens] = useState([]);
  useEffect(() => {
    setTokens(getTokenNames());
  }, []);
  return (
    <div id="token-preview-panel">
      <h2>Design tokens</h2>
      {/* For brevity just show all tokens */}
      {tokens.map((name) => (
        <div key={name} className="token-row">
          <span>{name}</span>
          <span>{getComputedStyle(document.documentElement).getPropertyValue(name).trim()}</span>
        </div>
      ))}
    </div>
  );
};

export default React.memo(TokenPreviewPanel);
